import React from "react";
import { useHistory } from "react-router-dom";
const Footer = () =>{
    const history = useHistory()
    return (
        <footer id="footer">
                <div className="row col-12">
                    <div className="col-sm-3 mag-A">
                        <p id="logo_word_header" className="logo_2">Smart Shopper.</p>
                    </div>
                    <div className="col-sm-5 mag-A" id="footer_header_middle">
                        <p id="footer_p_header">Sign up to our newsletter and immediately you get a 7% off for your first order:</p>
                    </div>
                    <div className="col-sm mag-A">
                        <input type="email" id="footer_input" placeholder="Enter your email"/>
                    </div>
                    <div className="col-sm-2 mag-A">
                        <button type="email" id="footer_button">
                            Subscribe
                        </button>
                    </div>
                </div>
                <hr id="line_footer"/>
                <div className='row col-12'>
                    <div className='col-sm' id="widthCol_100">
                        <p id="title_footer_2">Contact Us</p>
                        <ul id="middle_footer_ul">
                            <li>KG 7 Avenue</li>
                            <li>Kigali - Rwanda</li>
                            <li>+250 780 486 666</li>
                        </ul>
                    </div>
                    <div className='col-sm' id="widthCol_100">
                        <p id="title_footer_2">Our Store:</p>
                        <ul id="middle_footer_ul">
                            <li>Kimironko</li>
                            <li>Kacyiru</li>
                            <li>Nyarugenge</li>
                            <li>Kicukiro</li>
                        </ul>
                    </div>
                    <div className='col-sm' id="widthCol_100">
                        <p id="title_footer_2">Popular Categories</p>
                        <ul id="middle_footer_ul">
                            <li
                            onClick={(()=>{
                                history.push({
                                    pathname:"/shop/:living-room",
                                    state:{
                                        name:"Living room"
                                    }
                                })
                            })}
                            >Living room</li>
                            <li
                             onClick={(()=>{
                                history.push({
                                    pathname:"/shop/:chair-collection",
                                    state:{
                                        name:"Chair Collection"
                                    }
                                })
                            })}
                            >Chair collection</li>
                            <li
                            onClick={(()=>{
                                history.push({
                                    pathname:"/shop/:office-table",
                                    state:{
                                        name:"Office table"
                                    }
                                })
                            })}
                            >Office table</li>
                            <li
                             onClick={(()=>{
                                history.push({
                                    pathname:"/shop/:dining-room",
                                    state:{
                                        name:"Dining room"
                                    }
                                })
                            })}
                            >Dining room</li>
                            <li
                             onClick={(()=>{
                                history.push({
                                    pathname:"/shop/:gadern-chair",
                                    state:{
                                        name:"Gadern chair"
                                    }
                                })
                            })}
                            >Gadern chair</li>
                        </ul>
                    </div>
                    <div className='col-sm' id="widthCol_100">
                        <p id="title_footer_2">Shop Info</p>
                        <ul id="middle_footer_ul">
                            <li
                                onClick={(()=>{
                                    history.push('/our/story')
                                })}
                            >Our Story</li>
                            <li
                             onClick={(()=>{
                                history.push('/contact')
                            })}
                            >Contact us</li>
                            <li
                            onClick={(()=>{
                                history.push('/policy')
                            })}
                            >Policy</li>
                            <li
                             onClick={(()=>{
                                history.push('/carreer')
                            })}
                            >Carreer</li>
                        </ul>
                    </div>
                    <div className='col-sm' id="widthCol_100">
                        <p id="title_footer_2">Shop by</p>
                        <ul id="middle_footer_ul"
                        onClick={(()=>{
                            history.push('/shop')
                        })}
                        >
                            <li>New Arrival</li>
                            <li>Best Sleller</li>
                            <li>Features Product</li>
                            <li>Sale Off</li>
                        </ul>
                    </div>
                    <div className='col-sm' id="widthCol_100">
                        <p id="title_footer_2">Customer Support</p>
                        <ul id="middle_footer_ul">
                            <li
                            onClick={(()=>{
                                history.push('/')
                            })}
                            >The Blog</li>
                            <li
                            onClick={(()=>{
                                history.push('/faqs')
                            })}
                            >FAQs</li>
                            <li
                             onClick={(()=>{
                                history.push('/order/trancking')
                            })}
                            >Order Tracking</li>
                            {/* <li>Shipping and Returns</li> */}
                        </ul>
                    </div>
                </div>
                <div id="end_footer">
                    All Rights Reserved, The Smart Shopper.©2022 
                </div>
        </footer>
    )
}
export default Footer;